export default "__VITE_ASSET__AGhv1PRi__"